import { render, staticRenderFns } from "./OfferTitleDescription.vue?vue&type=template&id=60821b50&scoped=true"
import script from "./OfferTitleDescription.vue?vue&type=script&lang=js"
export * from "./OfferTitleDescription.vue?vue&type=script&lang=js"
import style0 from "./OfferTitleDescription.vue?vue&type=style&index=0&id=60821b50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60821b50",
  null
  
)

export default component.exports